// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"adb74b1a","239":"a2b9aeeb","455":"5ee3d670"}[chunkId] + ".chunk.js";
};